"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionEngineFacade = void 0;
const SessionEngineCore_1 = require("./SessionEngineCore");
/**
 * Facade that implements the ISessionEngine interface and exposes
 * the functionality of the Session Engine.
 *
 * The facade creates and holds references to all managers
 * and the core of the Session Engine.
 */
class SessionEngineFacade {
    constructor(properties) {
        this._sessionEngineCore = new SessionEngineCore_1.SessionEngineCore(properties);
        this._settingsManager = this._sessionEngineCore.settingsManager;
        this._outputManager = this._sessionEngineCore.outputManager;
        this._exportManager = this._sessionEngineCore.exportManager;
        this._customizationManager =
            this._sessionEngineCore.customizationManager;
        this._parameterManager = this._sessionEngineCore.parameterManager;
        this._fileUploadManager = this._sessionEngineCore.fileUploadManager;
        this._modelStateManager = this._sessionEngineCore.modelStateManager;
    }
    get automaticSceneUpdate() {
        return this._sessionEngineCore.automaticSceneUpdate;
    }
    set automaticSceneUpdate(value) {
        this._sessionEngineCore.automaticSceneUpdate = value;
    }
    get canUploadGLTF() {
        return this._fileUploadManager.canUploadGLTF;
    }
    get customizeOnParameterChange() {
        return this._customizationManager.customizeOnParameterChange;
    }
    set customizeOnParameterChange(value) {
        this._customizationManager.customizeOnParameterChange = value;
    }
    get excludeViewports() {
        return this._sessionEngineCore.excludeViewports;
    }
    set excludeViewports(value) {
        this._sessionEngineCore.excludeViewports = value;
    }
    get exports() {
        return this._exportManager.exports;
    }
    get guid() {
        return this._sessionEngineCore.guid;
    }
    get hasStoredSettings() {
        return this._settingsManager.hasStoredSettings;
    }
    get id() {
        return this._sessionEngineCore.id;
    }
    get initialized() {
        return this._sessionEngineCore.initialized;
    }
    get jwtToken() {
        return this._sessionEngineCore.jwtToken;
    }
    get loadSdtf() {
        return this._sessionEngineCore.loadSdtf;
    }
    set loadSdtf(value) {
        this._sessionEngineCore.loadSdtf = value;
    }
    get modelState() {
        return this._modelStateManager.modelState;
    }
    get modelViewUrl() {
        return this._sessionEngineCore.modelViewUrl;
    }
    get node() {
        return this._sessionEngineCore.node;
    }
    get outputs() {
        return this._outputManager.outputs;
    }
    get outputsFreeze() {
        return this._outputManager.outputsFreeze;
    }
    get parameterValues() {
        return this._parameterManager.parameterValues;
    }
    get parameters() {
        return this._parameterManager.parameters;
    }
    get refreshJwtToken() {
        return this._sessionEngineCore.refreshJwtToken;
    }
    set refreshJwtToken(value) {
        this._sessionEngineCore.refreshJwtToken = value;
    }
    get settingsEngine() {
        return this._settingsManager.settingsEngine;
    }
    get ticket() {
        return this._sessionEngineCore.ticket;
    }
    get updateCallback() {
        return this._sessionEngineCore.updateCallback;
    }
    set updateCallback(value) {
        this._sessionEngineCore.updateCallback = value;
    }
    get viewerSettings() {
        return this._settingsManager.viewerSettings;
    }
    applySettings(response, sections) {
        return this._settingsManager.applySettings(response, sections);
    }
    canGoBack() {
        return this._parameterManager.canGoBack();
    }
    canGoForward() {
        return this._parameterManager.canGoForward();
    }
    cancelCustomization() {
        return this._customizationManager.cancelCustomization();
    }
    close() {
        return this._sessionEngineCore.close();
    }
    createModelState(parameterValues, omitSessionParameterValues, image, data, arScene) {
        return this._modelStateManager.createModelState(parameterValues, omitSessionParameterValues, image, data, arScene);
    }
    customize(force, waitForViewportUpdate) {
        return this._customizationManager.customize(force, waitForViewportUpdate);
    }
    customizeParallel(parameterValues, loadOutputs) {
        return this._customizationManager.customizeParallel(parameterValues, loadOutputs);
    }
    customizeWithModelState(modelState) {
        return this._modelStateManager.customizeWithModelState(modelState);
    }
    getModelState(modelStateId) {
        return this._modelStateManager.getModelState(modelStateId);
    }
    goBack() {
        return this._parameterManager.goBack();
    }
    goForward() {
        return this._parameterManager.goForward();
    }
    init(parameterValues) {
        return this._sessionEngineCore.init(parameterValues);
    }
    loadCachedOutputsParallel(outputMapping, taskEventInfo, retry) {
        return this._outputManager.loadCachedOutputsParallel(outputMapping, taskEventInfo, retry);
    }
    requestExport(exportId, parameters, maxWaitTime) {
        return this._exportManager.requestExport(exportId, parameters, maxWaitTime);
    }
    requestExports(body, loadOutputs, maxWaitMsec) {
        return this._exportManager.requestExports(body, loadOutputs, maxWaitMsec);
    }
    resetSettings(sections) {
        return this._settingsManager.resetSettings(sections);
    }
    saveDefaultParameterValues() {
        return this._settingsManager.saveDefaultParameterValues();
    }
    saveSettings(json) {
        return this._settingsManager.saveSettings(json);
    }
    saveUiProperties(saveInSettings) {
        return this._settingsManager.saveUiProperties(saveInSettings);
    }
    setJwtToken(token) {
        return this._sessionEngineCore.setJwtToken(token);
    }
    updateOutputs(taskEventInfo, waitForViewportUpdate) {
        return this._outputManager.updateOutputs(taskEventInfo, waitForViewportUpdate);
    }
    uploadFile(parameterId, data, type) {
        return this._fileUploadManager.uploadFile(parameterId, data, type);
    }
    uploadFileParameters(parameterValues) {
        return this._fileUploadManager.uploadFileParameters(parameterValues);
    }
    uploadGLTF(blob, conversion) {
        return this._fileUploadManager.uploadGLTF(blob, conversion);
    }
    uploadSDTF(arrayBuffers) {
        return this._fileUploadManager.uploadSDTF(arrayBuffers);
    }
}
exports.SessionEngineFacade = SessionEngineFacade;
//# sourceMappingURL=SessionEngineFacade.js.map